import { render, staticRenderFns } from "./BrowserChrome.vue?vue&type=template&id=a6b29c7a"
import script from "./BrowserChrome.vue?vue&type=script&lang=js"
export * from "./BrowserChrome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports